import smokerGuy from "assets/images/smoker-guy-1.gif";
import lady from "assets/images/lady-gif.gif";
import manwithbeer from "assets/images/man-with-beer.gif";
import share from "assets/images/share.svg";
import chevronLeft from "assets/images/chevron-left.svg";
import warning from "assets/images/warning.svg";
import close from "assets/images/close.svg";
import expand from "assets/images/expand.svg";
import rightArrow from "assets/images/right-arrow.svg";
import gangstaPropertyIcon from "assets/images/gangsta-properties-icon.svg";
import gangstaBet from "assets/images/gangsta-bet-11.svg";
import suitIcon from "assets/images/suit-icon.svg";
import shoeIcon from "assets/images/shoe-icon.svg";
import cigarIcon from "assets/images/cigar-icon.svg";
import sold from "assets/images/sold.svg";
import cubical from "assets/images/cubic.svg";
import price from "assets/images/price.svg";
import profile from "assets/images/profile.svg";
import trade from "assets/images/trade.svg";
import heroSection from "assets/images/banner.jpeg";
import collectiveGangsta from "assets/images/collective-gangsta.svg";
import table from "assets/images/table.svg";
import modalClose from "assets/images/modal-close.svg";
import walletCustomer from "assets/images/robot.svg";
import iconxNotDetected from "assets/images/iconx-not-detected.png";
import spinner from "assets/images/spinner.svg";
import backgroundWallet from "assets/images/background-wallet.svg";
import completeTransaction from "assets/images/complete-transaction.svg";
import connectWallet from "assets/images/connect-wallet.svg";
import failedTransaction from "assets/images/failed-transaction.svg";
import dottedLine from "assets/images/dotted-line.svg";
import wallet from "assets/images/connect-wallet.png";
import emptyMarketPlace from "assets/images/empty-marketplace.svg";
import optionClose from "assets/images/option-close.svg";
import download from "assets/images/download.svg";
import ledger from "assets/images/ledger.svg";
import iconex from "assets/images/iconex.svg";
import tickMark from "assets/images/tick-mark.svg";
import search from "assets/images/search.svg";
import copied from "assets/images/copy.svg";
import plus from "assets/images/plus.svg";
import sortIcon from "assets/images/sort.svg";
import soldActivity from "assets/images/soldActivity.svg";
import SKILL_UPGRADE from "assets/images/activity_stat_change_icon.svg";
import STORY_ADDED from "assets/images/activity_story.svg";
import NAME_CHANGE from "assets/images/activity_name_change_icon.svg";
import FOR_SALE from "assets/images/activity_on_sale_icon.svg";
import TYPE_DETECTIVE_ICON from "assets/images/gansta_class_icon/detective.png";
import TYPE_GANGSTER_ICON from "assets/images/gansta_class_icon/gangsta.png";
import GBET_LOGO_TRANSPARENT from "assets/images/gbet_logo_transparent.png";
import STORY_EMPTY_ICON from "assets/images/stories-assets/stories-empty-icon.png";
import STORY_HYPERLINK_ICON from "assets/images/stories-assets/Hyperlink.png";
import STORY_DELETE_ICON from "assets/images/stories-assets/Delete.png";
import STORY_ADD_ICON from "assets/images/stories-assets/add.png";
import STORY_INFO_ICON from "assets/images/stories-assets/info-circle.png";
import STORY_FIRE_ICON from "assets/images/stories-assets/Chest.png";
import STORY_CHEST_ICON from "assets/images/stories-assets/Fire.png";
import WALLET_ICON_ROUND from "assets/images/wallet-3.svg";
import TRANSFER_NFT from "assets/images/transfer-nft.svg";
import TRANSFER_NFT_ACTIVITY from "assets/images/transfer_nft_activity.svg";
import CROWN_LOGO from "assets/images/crown.png";
import GOLDEN_KEY_LOGO from "assets/images/golden_key.png";
import NEW_GB_LOGO from "assets/images/wallet-gb.png";
import DOWN_ARROW_ICON from "assets/images/arrow-down.svg";
import PLACEHOLDER from "assets/images/placeholder_ill.png";

import storyicon from "assets/images/storyicon.svg";

const STORIES = {
  EMPTY_ICON: STORY_EMPTY_ICON,
  HYPERLINK: STORY_HYPERLINK_ICON,
  DELETE: STORY_DELETE_ICON,
  ADD: STORY_ADD_ICON,
  INFO: STORY_INFO_ICON,
  FIRE: STORY_FIRE_ICON,
  CHEST: STORY_CHEST_ICON,
} as const;

const GANGSTABET_STORY = {
  STORY_ICON: storyicon,
} as const;

import CRAFT_LOGO_TRANSPARENT from "assets/images/craft-logo.svg";

const CRAFT_LOGO = {
  SOURCE: CRAFT_LOGO_TRANSPARENT,
} as const;

const GBET_LOGO = {
  SOURCE: GBET_LOGO_TRANSPARENT,
} as const;

const CLASS_TYPE_ICON = {
  GANGSTER: TYPE_GANGSTER_ICON,
  DETECTIVE: TYPE_DETECTIVE_ICON,
} as const;

const DOWN_ARROW = {
  SOURCE: DOWN_ARROW_ICON,
} as const;

const PLACEHOLDER_IMAGE = {
  SOURCE: PLACEHOLDER,
} as const;

const NEW_GB = {
  SOURCE: NEW_GB_LOGO,
} as const;

const GOLDEN_KEY = {
  SOURCE: GOLDEN_KEY_LOGO,
} as const;

const CROWN = {
  SOURCE: CROWN_LOGO,
} as const;

const TRANSFER_NFT_ICON = {
  SOURCE: TRANSFER_NFT,
} as const;

const TRANSFER_NFT_ACTIVITY_ICON = {
  SOURCE: TRANSFER_NFT_ACTIVITY,
} as const;

const WALLET_ICON = {
  SOURCE: WALLET_ICON_ROUND,
} as const;

const ACTIVITY_ICONS = {
  SKILL_UPGRADE,
  STORY_ADDED,
  NAME_CHANGE,
  FOR_SALE,
} as const;

const CONNECT_WALLET = {
  SOURCE: connectWallet,
} as const;

const ICONEX = {
  SOURCE: iconex,
} as const;

const LEDGER = {
  SOURCE: ledger,
} as const;

const NEW_GB_ICON = {
  SOURCE: NEW_GB_LOGO,
} as const;

// Add missing constants that are being imported
const HERO_SECTION = {
  SOURCE: heroSection,
} as const;

const EMPTY_MARKET_PLACE = {
  SOURCE: emptyMarketPlace,
} as const;

const RIGHT_ARROW = {
  SOURCE: rightArrow,
} as const;

const CHEVRON_LEFT = {
  SOURCE: chevronLeft,
} as const;

const OPTION_CLOSE = {
  SOURCE: optionClose,
} as const;

// Add more missing constants
const GANGSTA_BET_11 = {
  SOURCE: gangstaBet,
} as const;

const LADY = {
  SOURCE: lady,
} as const;

const ICON_PLUS = {
  SOURCE: plus,
} as const;

const MODAL_CLOSE = {
  SOURCE: modalClose,
} as const;

const DOWNLOAD = {
  SOURCE: download,
} as const;

// Add more missing constants
const ClOSE = {
  SOURCE: close,
} as const;

const SHOES = {
  SOURCE: shoeIcon,
} as const;

const SUIT = {
  SOURCE: suitIcon,
} as const;

const CIGAR = {
  SOURCE: cigarIcon,
} as const;

// Add missing SPINNER constant
const SPINNER = {
  SOURCE: spinner,
} as const;

// Add more missing critical constants
const ACTIVITY_LOG_ICONS = {
  SKILL_UPGRADE,
  STORY_ADDED,
  NAME_CHANGE,
  FOR_SALE,
} as const;

const COPIED_ICON = {
  SOURCE: copied,
} as const;

const SMOKER_GUY = {
  SOURCE: smokerGuy,
} as const;

const GANGSTA_HEAD = {
  SOURCE: gangstaBet,
} as const;

const ALERT = {
  SOURCE: warning,
} as const;

const TICK_MARK = {
  SOURCE: tickMark,
} as const;

const ICONX_NOT_DETECTED = {
  SOURCE: iconxNotDetected,
} as const;

const MAN_WITH_BEER = {
  SOURCE: manwithbeer,
} as const;

const COLLECTIVE_GANGSTA = {
  SOURCE: collectiveGangsta,
} as const;

const SOLD = {
  SOURCE: sold,
} as const;

const EMPTY_TABLE = {
  SOURCE: table,
} as const;

const EXPAND = {
  SOURCE: expand,
} as const;

// Add missing BACKGROUND_WALLET constant
const BACKGROUND_WALLET = {
  SOURCE: backgroundWallet,
} as const;

// Add missing COMPLETE_TRANSACTION constant
const COMPLETE_TRANSACTION = {
  SOURCE: completeTransaction,
} as const;

// Add missing FAILED_TRANSACTION constant
const FAILED_TRANSACTION = {
  SOURCE: failedTransaction,
} as const;

// Add missing SEARCH_ICON constant
const SEARCH_ICON = {
  SOURCE: search,
} as const;

// Add missing DOTTED_LINE constant
const DOTTED_LINE = {
  SOURCE: dottedLine,
} as const;

// Add missing WALLET constant
const WALLET = {
  SOURCE: wallet,
} as const;

// Add missing WALLET_CUSTOMER constant
const WALLET_CUSTOMER = {
  SOURCE: walletCustomer,
} as const;

export {
  smokerGuy,
  lady,
  manwithbeer,
  share,
  chevronLeft,
  warning,
  close,
  expand,
  rightArrow,
  gangstaPropertyIcon,
  gangstaBet,
  suitIcon,
  shoeIcon,
  cigarIcon,
  sold,
  cubical,
  price,
  profile,
  trade,
  heroSection,
  collectiveGangsta,
  table,
  modalClose,
  walletCustomer,
  iconxNotDetected,
  spinner,
  backgroundWallet,
  completeTransaction,
  connectWallet,
  failedTransaction,
  dottedLine,
  wallet,
  emptyMarketPlace,
  optionClose,
  download,
  ledger,
  iconex,
  tickMark,
  search,
  copied,
  plus,
  sortIcon,
  soldActivity,
  SKILL_UPGRADE,
  STORY_ADDED,
  NAME_CHANGE,
  FOR_SALE,
  TYPE_DETECTIVE_ICON,
  TYPE_GANGSTER_ICON,
  GBET_LOGO_TRANSPARENT,
  STORY_EMPTY_ICON,
  STORY_HYPERLINK_ICON,
  STORY_DELETE_ICON,
  STORY_ADD_ICON,
  STORY_INFO_ICON,
  STORY_FIRE_ICON,
  STORY_CHEST_ICON,
  WALLET_ICON_ROUND,
  TRANSFER_NFT,
  TRANSFER_NFT_ACTIVITY,
  CROWN_LOGO,
  GOLDEN_KEY_LOGO,
  NEW_GB_LOGO,
  DOWN_ARROW_ICON,
  PLACEHOLDER,
  storyicon,
  STORIES,
  GANGSTABET_STORY,
  CRAFT_LOGO_TRANSPARENT,
  CRAFT_LOGO,
  GBET_LOGO,
  CLASS_TYPE_ICON,
  DOWN_ARROW,
  PLACEHOLDER_IMAGE,
  NEW_GB,
  GOLDEN_KEY,
  CROWN,
  TRANSFER_NFT_ICON,
  TRANSFER_NFT_ACTIVITY_ICON,
  WALLET_ICON,
  ICONEX,
  LEDGER,
  CONNECT_WALLET,
  HERO_SECTION,
  EMPTY_MARKET_PLACE,
  RIGHT_ARROW,
  CHEVRON_LEFT,
  OPTION_CLOSE,
  GANGSTA_BET_11,
  LADY,
  ICON_PLUS,
  MODAL_CLOSE,
  DOWNLOAD,
  ClOSE,
  SHOES,
  SUIT,
  CIGAR,
  SPINNER,
  ACTIVITY_LOG_ICONS,
  COPIED_ICON,
  SMOKER_GUY,
  GANGSTA_HEAD,
  ALERT,
  TICK_MARK,
  ICONX_NOT_DETECTED,
  MAN_WITH_BEER,
  COLLECTIVE_GANGSTA,
  SOLD,
  EMPTY_TABLE,
  EXPAND,
  BACKGROUND_WALLET,
  COMPLETE_TRANSACTION,
  FAILED_TRANSACTION,
  SEARCH_ICON,
  DOTTED_LINE,
  WALLET,
  WALLET_CUSTOMER,
  CUBICAL,
  PRICE,
  PROFILE,
  TRADE,
}; 